"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingPeriodForm = BillingPeriodForm;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var date_fns_1 = require("date-fns");
var react_3 = require("react");
var content_dialog_1 = require("../../../features/thunks/content-dialog");
var hooks_1 = require("../../../store/hooks");
function buildDescription(start, end) {
    if (!start || !end)
        return "";
    try {
        return "".concat((0, date_fns_1.format)(new Date(start), "MMM d, yyyy"), " - ").concat((0, date_fns_1.format)(new Date(end), "MMM d, yyyy"));
    }
    catch (_a) {
        return "";
    }
}
function BillingPeriodForm(props) {
    var _this = this;
    var _a;
    var onSubmit = props.onSubmit, _b = props.mode, mode = _b === void 0 ? "create" : _b, initialData = props.initialData;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var isEditMode = mode === "edit";
    var _c = (0, react_3.useState)((initialData === null || initialData === void 0 ? void 0 : initialData.period) || ""), period = _c[0], setPeriod = _c[1];
    var _d = (0, react_3.useState)((initialData === null || initialData === void 0 ? void 0 : initialData.startDate) ? initialData.startDate.split("T")[0] : ""), startDate = _d[0], setStartDate = _d[1];
    var _e = (0, react_3.useState)((initialData === null || initialData === void 0 ? void 0 : initialData.endDate) ? initialData.endDate.split("T")[0] : ""), endDate = _e[0], setEndDate = _e[1];
    var _f = (0, react_3.useState)((initialData === null || initialData === void 0 ? void 0 : initialData.description) || ""), description = _f[0], setDescription = _f[1];
    var userEditedDescription = (0, react_3.useRef)(!!(initialData === null || initialData === void 0 ? void 0 : initialData.description));
    var _g = (0, react_3.useState)((_a = initialData === null || initialData === void 0 ? void 0 : initialData.isActive) !== null && _a !== void 0 ? _a : true), isActive = _g[0], setIsActive = _g[1];
    var _h = (0, react_3.useState)(new Set()), errors = _h[0], setErrors = _h[1];
    var _j = (0, react_3.useState)(false), isSubmitting = _j[0], setIsSubmitting = _j[1];
    var handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
        var newErrors, success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newErrors = new Set();
                    if (!period.trim())
                        newErrors.add("period");
                    if (!startDate)
                        newErrors.add("startDate");
                    if (!endDate)
                        newErrors.add("endDate");
                    if (newErrors.size > 0) {
                        setErrors(newErrors);
                        (0, react_1.addToast)({
                            title: "Validation Failed",
                            description: "Please fill in Period, Start Date, and End Date.",
                            color: "danger",
                        });
                        return [2 /*return*/];
                    }
                    setIsSubmitting(true);
                    return [4 /*yield*/, onSubmit({ period: period, startDate: startDate, endDate: endDate, description: description, isActive: isActive })];
                case 1:
                    success = _a.sent();
                    setIsSubmitting(false);
                    if (success) {
                        dispatch((0, content_dialog_1.closeContentDialogThunk)());
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCancel = function () {
        dispatch((0, content_dialog_1.closeContentDialogThunk)());
    };
    var clearError = function (field) {
        setErrors(function (prev) {
            var next = new Set(prev);
            next.delete(field);
            return next;
        });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4 p-6", children: [(0, jsx_runtime_1.jsx)(react_1.Input, { label: "Period (YYYY-MM)", placeholder: "e.g. 2025-06", value: period, onValueChange: function (v) {
                            setPeriod(v);
                            clearError("period");
                        }, variant: "bordered", isRequired: true, isInvalid: errors.has("period"), isReadOnly: isEditMode, startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:calendar-linear", className: "text-gray-400" }) }), (0, jsx_runtime_1.jsx)(react_1.Input, { type: "date", label: "Start Date", value: startDate, onValueChange: function (v) {
                            setStartDate(v);
                            clearError("startDate");
                            if (!userEditedDescription.current) {
                                setDescription(buildDescription(v, endDate));
                            }
                        }, variant: "bordered", isRequired: true, isInvalid: errors.has("startDate") }), (0, jsx_runtime_1.jsx)(react_1.Input, { type: "date", label: "End Date", value: endDate, onValueChange: function (v) {
                            setEndDate(v);
                            clearError("endDate");
                            if (!userEditedDescription.current) {
                                setDescription(buildDescription(startDate, v));
                            }
                        }, variant: "bordered", isRequired: true, isInvalid: errors.has("endDate") }), (0, jsx_runtime_1.jsx)(react_1.Textarea, { label: "Description", placeholder: "Description of this billing period...", value: description, onValueChange: function (v) {
                            setDescription(v);
                            userEditedDescription.current = v !== buildDescription(startDate, endDate);
                        }, variant: "bordered", minRows: 2, maxRows: 4 }), isEditMode && ((0, jsx_runtime_1.jsx)(react_1.Switch, { isSelected: isActive, onValueChange: setIsActive, size: "sm", children: "Active" }))] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex justify-end gap-2 border-t border-gray-100 px-6 py-4", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "light", onPress: handleCancel, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { color: "primary", onPress: handleSubmit, isLoading: isSubmitting, children: isEditMode ? "Update" : "Create" })] })] }));
}
